import { createActionGroup, props } from '@ngrx/store';
import { IAccountLedgerPage } from '../models/account-ledger.model';

/**
 * The Kontenblatt. Every action carries project and account: an answer for an account the user has
 * already left is dropped, or the previous account's postings would land in the new one's sheet.
 */
export const accountLedgerActions = createActionGroup({
    source: 'ABCP Account Ledger',
    events: {
        Load: props<{ projectId: string; accountId: string }>(),
        'Load Success': props<{ projectId: string; accountId: string; page: IAccountLedgerPage }>(),
        'Load Failure': props<{ projectId: string; accountId: string; error: string }>(),
        'Load More': props<{ projectId: string; accountId: string; cursor: string }>(),
        'Load More Success': props<{ projectId: string; accountId: string; page: IAccountLedgerPage }>(),
        'Load More Failure': props<{ projectId: string; accountId: string; error: string }>(),
    },
});
